import commandStatuses from "../../assets/conf/command_statuses.json";
import i18n from "@/core/i18n";

export const throwOnCommandError = (status: number) => {
  if (status < 10) {
    return;
  } else {
    const msg =
      commandStatuses.find((s) => s.status === status)?.msg ?? "Unavailable";
    throw new Error(i18n.global.t(msg));
  }
};
